import { LIFECYCLE, useLifecycle } from 'hooks/useLifecycle';

export const useSawBoxOnboarding = () => {
  const { lifecycle } = useLifecycle();

  return lifecycle?.[LIFECYCLE.sawBoxOnboarding] || {};
};
